export default (elem, type = 'default') => {
  const bounding = elem.getBoundingClientRect();
  const threshold = window.innerHeight * 0.75;

  if (type === 'default') {
    return (
      bounding.bottom >= window.innerHeight / 2 &&
    bounding.top <= window.innerHeight / 2
    );
  }

  if (type === 'bottom') {
    return bounding.top <= threshold && bounding.bottom >= threshold;
  }
};
